import { apiMethodContext } from "libs/utils/http/builder/UrlConfig";
import { CloudConsoleClient, IAMClient } from "libs/utils/http/client/HttpClient";
import { APIMethod, APIResource } from "libs/utils/http/decorator/UrlDecorator";
import { from } from "rxjs";
import { formatError } from "./ApplicationService";


interface IConsent {
    applicationLogo: string;
    privacyPolicyUrl?: string;
    termsOfServiceUrl?: string;
}


@APIResource(CloudConsoleClient, "publisher/v2/applications")
class ConsentServiceFactory {

    @APIMethod("/:applicationId/consent",{options: {noTrailingSlash: true}})
    public getConsent(applicationId: string) {
        const context = apiMethodContext(arguments);

        return from(new Promise<IConsent>((resolve, reject) => {
            CloudConsoleClient.get<IConsent>(context, {
                params: {
                    applicationId
                }
            },).then(
                (response: any)  => resolve(response.data),
                (error: any)  => reject(formatError(error, "Unknown error occured while getting the Application Consent")));
        }))
    }

    @APIMethod("/:applicationId/consent", {options: {noTrailingSlash: true}})
    public updateConsent(applicationId: string, payload: FormData) {
        const context = apiMethodContext(arguments);

        return from(new Promise<IConsent>((resolve, reject) => {
            CloudConsoleClient.put<IConsent>(context, payload, {
                    params: {
                        applicationId
                    }
            },).then(
                (response: any)  => resolve(response.data),
                (error: any)  => reject(formatError(error, "Unknown error occured while updating the Application Consent")));
        }))
    }

   

}

export const ConsentService = new ConsentServiceFactory();

export default ConsentService;
